import React from "react";
import { Main, ArticleContainer } from "../../styles/Container";
import { Heading2 } from "../../styles/Heading";
import Head from "@nvdb-rapport/shared/src/components/Head";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { UIAction, UIModel } from "../../update/ui";

interface SearchFilterProps {
  uiState: UIModel;
  uiDispatch: React.Dispatch<UIAction>;
}

export default function Error({ uiState, uiDispatch }: SearchFilterProps) {
  const errors = uiState.errors;

  if (errors.length === 0) return null;

  const handleClose = () => {
    uiDispatch({ type: "ClearError" });
  };

  return (
    <>
      <Head
        title="FEIL"
        siteTitle="Vegnett og objektdata for driftskontrakter"
        status="red"
      />
      <Main style={{ textAlign: "left" }}>
        <ArticleContainer>
          <Heading2>Noe gikk galt</Heading2>

          {errors.map((errorData, index) => (
            <Alert severity="error" key={index} onClose={() => handleClose()}>
              <AlertTitle style={{ fontWeight: "bold" }}>
                {String(errorData.title)}
              </AlertTitle>
              {String(errorData.message)}
            </Alert>
          ))}
        </ArticleContainer>
      </Main>
    </>
  );
}
